export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_COLUMN_WIDTH = "150px";

export const PIN_POSITIONS = {
  LEFT: "left",
  RIGHT: "right",
  NONE: "none",
};

export const TABLE_DATA = Array.from({ length: 100 }, (_, index) => ({
  id: index + 1,
  name: `User ${index + 1}`,
  email: `user${index + 1}@example.com`,
  phone: `(${Math.floor(Math.random() * 900) + 100}) ${
    Math.floor(Math.random() * 900) + 100
  }-${Math.floor(Math.random() * 9000) + 1000}`,
  age: Math.floor(Math.random() * 40) + 20,
  status: ["Active", "Inactive", "Pending", "Suspended"][
    Math.floor(Math.random() * 4)
  ],
  department: ["Engineering", "Marketing", "Sales", "Support", "HR"][
    Math.floor(Math.random() * 5)
  ],
  joinedDate: new Date(
    Date.now() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 365 * 3)
  ).toLocaleDateString(),

  active: Math.random() > 0.3,
}));
